import React from 'react';
import { FerringWordmark } from './concept/FerringWordmark';
type PresentationBarProps = {
  onOpenConcept: () => void;
};
export function PresentationBar({
  onOpenConcept
}: PresentationBarProps) {
  return <div className="border-b border-rule bg-white" data-id="element-215" data-mp="32xgww4ji15o8">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-5 md:px-8" data-id="element-216" data-mp="32ul1onz1cv3h">
        <div className="flex min-w-0 items-center gap-5" data-id="element-217" data-mp="2a7qjjxpoy7t6">
          <FerringWordmark data-id="element-218" data-mp="2a9bcxk09rkpg" />
          <span className="hidden h-7 w-px bg-rule sm:block" aria-hidden="true" data-id="element-219" data-mp="2a5x9e8fvd5gf" />
          <p className="hidden truncate font-mono text-[11px] tracking-[0.24em] text-graphite/70 sm:block" data-id="element-220" data-mp="2f736eigkbevr">
            FERRING × SNAKKER™ · ILLUSTRATIVE PROTOTYPE
          </p>
        </div>
        <button type="button" onClick={onOpenConcept} className="inline-flex shrink-0 items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-medium text-white transition-[background-color,transform] duration-150 ease-out hover:bg-ferring active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ferring" data-id="element-221" data-mp="2o0g4dythh6op">
          The concept
        </button>
      </div>
    </div>;
}